import React from 'react';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import { Widget } from '@typeform/embed-react';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const Quiz = ({ consentCode, errorText }) => {
  const isConsentGranted = useConsentCheck(consentCode);
  const isClient = useClient();

  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <div className="mb-24 p-8 px-3 lg:px-8">
            <ErrorCookiesSettings errorText={errorText} />
          </div>
        </Delay>
      )}
      {isConsentGranted && (
        <div className="h-[600px]">
          <Widget
            id="IRIOMpNV"
            style={{ height: '100%' }}
          />
        </div>
      )}
    </div>
  );
};

export default Quiz;
